(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function decodeEntities(value) {
    if (value == null) return '';
    var str = String(value);
    if (str.indexOf('&') === -1) return str;
    var textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  }

  function decodeDeep(value) {
    if (Array.isArray(value)) {
      return value.map(decodeDeep);
    }
    if (value && typeof value === 'object') {
      var out = {};
      Object.keys(value).forEach(function (key) {
        out[key] = decodeDeep(value[key]);
      });
      return out;
    }
    if (typeof value === 'string') return decodeEntities(value);
    return value;
  }

  function parseConfig(root) {
    var empty = {
      categories: [],
      emailTemplate: '',
      whatsappTemplate: '',
      verifyEndpoint: '',
      whatsappPhone: '',
      whatsappApikey: '',
      notifyEmail: 'hello@tedco.ai',
      ntfyTopic: 'tedco-ambassador-interest',
    };
    var node = root.querySelector('[data-ted-ambassador-config]');
    if (!node) return empty;
    try {
      return decodeDeep(JSON.parse(node.textContent));
    } catch (e) {
      return empty;
    }
  }

  function notifyWhatsApp(config, message) {
    var phone = String(config.whatsappPhone || '')
      .replace(/[^\d+]/g, '')
      .trim();
    var apikey = String(config.whatsappApikey || '').trim();
    if (!phone || !apikey || !message) return;
    var url =
      'https://api.callmebot.com/whatsapp.php?phone=' +
      encodeURIComponent(phone) +
      '&text=' +
      encodeURIComponent(message) +
      '&apikey=' +
      encodeURIComponent(apikey);
    try {
      var img = new Image();
      img.referrerPolicy = 'no-referrer';
      img.src = url;
    } catch (e) {}
  }

  function notifyNtfy(config, message) {
    var topic = String(config.ntfyTopic || '').trim();
    if (!topic || !message) return Promise.resolve();
    return fetch('https://ntfy.sh/' + encodeURIComponent(topic), {
      method: 'POST',
      body: message,
      headers: {
        Title: 'Ted&Co Ambassador — interested',
        Priority: 'high',
        Tags: 'teddy_bear,email',
      },
    }).catch(function () {});
  }

  function notifyInterestEmail(config, data) {
    var email = String(config.notifyEmail || 'hello@tedco.ai').trim();
    if (!email) return Promise.resolve();
    var body = buildEmailBody(config.emailTemplate, data);
    return fetch('https://formsubmit.co/ajax/' + encodeURIComponent(email), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        name: data.instagram || 'Ambassador applicant',
        Instagram: data.instagram || '',
        Followers: data.followers || '',
        Category: data.category || '',
        message: body || 'I am interested',
        _subject: "Ted&Co Ambassador — I'm interested",
        _template: 'table',
        _captcha: false,
      }),
    }).catch(function () {});
  }

  function normalizeUsername(value) {
    return String(value || '')
      .trim()
      .replace(/^@+/, '')
      .replace(/\s+/g, '');
  }

  function formatCount(n) {
    return Number(n).toLocaleString();
  }

  function classify(categories, count) {
    var n = Number(count);
    if (!isFinite(n) || n < 0) return null;
    for (var i = 0; i < categories.length; i++) {
      var cat = categories[i];
      var min = cat.min;
      var max = cat.max == null ? Infinity : cat.max;
      if (n >= min && n <= max) return cat;
    }
    return categories[categories.length - 1] || null;
  }

  function show(el) {
    if (!el) return;
    el.hidden = false;
    el.classList.add('is-visible');
  }

  function hide(el) {
    if (!el) return;
    el.hidden = true;
    el.classList.remove('is-visible', 'is-active');
  }

  function createParticles(container) {
    if (!container || prefersReducedMotion()) return;
    var count = window.innerWidth < 768 ? 14 : 24;
    for (var i = 0; i < count; i++) {
      var particle = document.createElement('span');
      var isStar = i % 3 === 0;
      particle.className =
        'ted-ambassador__particle' + (isStar ? ' ted-ambassador__particle--star' : '');
      particle.style.left = Math.random() * 100 + '%';
      particle.style.top = Math.random() * 100 + '%';
      particle.style.animationDuration = 7 + Math.random() * 10 + 's';
      particle.style.animationDelay = Math.random() * 6 + 's';
      particle.style.opacity = String(0.15 + Math.random() * 0.35);
      container.appendChild(particle);
    }
  }

  function revealOnLoad(root) {
    requestAnimationFrame(function () {
      root.classList.add('is-ready');
    });

    var targets = root.querySelectorAll('[data-ted-reveal]');
    if (prefersReducedMotion()) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function smoothScrollTo(target) {
    if (!target) return;
    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    var top = target.getBoundingClientRect().top + window.pageYOffset - 24;
    window.scrollTo({ top: top, behavior: behavior });
  }

  function buildEmailBody(template, data) {
    return String(template || '')
      .replace(/\{\{\s*instagram_username\s*\}\}/g, data.instagram)
      .replace(/\{\{\s*email\s*\}\}/g, data.email || 'Contact via Instagram')
      .replace(/\{\{\s*followers_count\s*\}\}/g, data.followers)
      .replace(/\{\{\s*creator_category\s*\}\}/g, data.category);
  }

  function renderList(container, items, icon) {
    if (!container) return;
    container.innerHTML = '';
    (items || []).forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'ted-ambassador__list-item';
      li.innerHTML =
        '<span class="ted-ambassador__list-mark" aria-hidden="true">' +
        icon +
        '</span><span class="ted-ambassador__list-text">' +
        item +
        '</span>';
      container.appendChild(li);
    });
  }

  function renderCategory(ui, category, followers, config) {
    ui.categoryRange.textContent = category.range || '';
    ui.categoryTitle.textContent = category.title || '';
    ui.categoryDesc.textContent = category.description || '';
    renderList(ui.baseRules, config.baseRules || [], '•');
    renderList(ui.categoryDo, category.do || [], '→');
    renderList(ui.categoryBenefits, category.benefits || [], '✓');

    var categories = config.categories || [];
    var index = -1;
    for (var i = 0; i < categories.length; i++) {
      if (categories[i].id === category.id) {
        index = i;
        break;
      }
    }

    if (ui.nextUnlock && ui.nextText) {
      if (index >= 0 && index < categories.length - 1) {
        var next = categories[index + 1];
        var remaining = Math.max(0, Number(next.min) - Number(followers));
        var text = String(config.nextTemplate || '')
          .replace(/\{\{\s*remaining\s*\}\}/g, formatCount(remaining))
          .replace(/\{\{\s*next_title\s*\}\}/g, next.title || '')
          .replace(/\{\{\s*next_perk\s*\}\}/g, category.unlockTeaser || '');
        ui.nextText.textContent = text;
        show(ui.nextUnlock);
      } else if (config.topTierNote) {
        ui.nextText.textContent = config.topTierNote;
        show(ui.nextUnlock);
      } else {
        hide(ui.nextUnlock);
      }
    }

    if (ui.perk) {
      if (category.perk) {
        ui.perk.textContent = category.perk;
        show(ui.perk);
      } else {
        hide(ui.perk);
      }
    }
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  async function tryVerifyFollowers(endpoint, username) {
    if (!endpoint) return null;
    var urls = [endpoint];
    // Allow configuring either the full path or just the origin.
    if (endpoint.indexOf('/api/instagram/followers') === -1) {
      urls.push(endpoint.replace(/\/$/, '') + '/api/instagram/followers');
    }

    for (var i = 0; i < urls.length; i++) {
      var url = urls[i];
      try {
        var response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ username: username }),
        });
        if (!response.ok) {
          // Fallback GET for simple proxies / workers
          response = await fetch(
            url + (url.indexOf('?') >= 0 ? '&' : '?') + 'username=' + encodeURIComponent(username),
            { method: 'GET', headers: { Accept: 'application/json' } }
          );
        }
        if (!response.ok) continue;
        var data = await response.json();
        var followers =
          data &&
          (data.followers != null
            ? data.followers
            : data.follower_count != null
              ? data.follower_count
              : data.data && data.data.user && data.data.user.edge_followed_by
                ? data.data.user.edge_followed_by.count
                : null);
        if (followers == null || !isFinite(Number(followers))) continue;
        return Number(followers);
      } catch (e) {
        // try next url
      }
    }
    return null;
  }

  function initSection(sectionRoot) {
    var root = sectionRoot.querySelector('.ted-ambassador') || sectionRoot;
    var config = parseConfig(sectionRoot);
    var state = {
      instagram: '',
      followers: null,
      categoryTitle: '',
    };

    var ui = {
      particles: root.querySelector('[data-ted-particles]'),
      lookupForm: root.querySelector('[data-ted-lookup-form]'),
      username: root.querySelector('[data-ted-username]'),
      checkBtn: root.querySelector('[data-ted-check-btn]'),
      progress: root.querySelector('[data-ted-progress]'),
      progressBar: root.querySelector('[data-ted-progress-bar]'),
      manual: root.querySelector('[data-ted-manual]'),
      checker: root.querySelector('[data-ted-checker]'),
      manualForm: root.querySelector('[data-ted-manual-form]'),
      followers: root.querySelector('[data-ted-followers]'),
      result: root.querySelector('[data-ted-result]'),
      categoryCard: root.querySelector('[data-ted-category-card]'),
      categoryRange: root.querySelector('[data-ted-category-range]'),
      categoryTitle: root.querySelector('[data-ted-category-title]'),
      categoryDesc: root.querySelector('[data-ted-category-desc]'),
      baseRules: root.querySelector('[data-ted-base-rules]'),
      categoryDo: root.querySelector('[data-ted-category-do]'),
      categoryBenefits: root.querySelector('[data-ted-category-benefits]'),
      nextUnlock: root.querySelector('[data-ted-next-unlock]'),
      nextText: root.querySelector('[data-ted-next-text]'),
      perk: root.querySelector('[data-ted-perk]'),
      interest: root.querySelector('[data-ted-interest]'),
      interestSubmit: root.querySelector('[data-ted-interest-submit]'),
      modal: root.querySelector('[data-ted-modal]'),
    };

    createParticles(ui.particles);
    revealOnLoad(root);

    root.querySelectorAll('[data-ted-scroll-to]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        smoothScrollTo(target);
      });
    });

    function openModal() {
      if (!ui.modal) return;
      ui.modal.hidden = false;
      document.documentElement.classList.add('ted-ambassador-modal-open');
      requestAnimationFrame(function () {
        ui.modal.classList.add('is-open');
      });
    }

    function closeModal() {
      if (!ui.modal) return;
      ui.modal.classList.remove('is-open');
      document.documentElement.classList.remove('ted-ambassador-modal-open');
      setTimeout(function () {
        ui.modal.hidden = true;
      }, prefersReducedMotion() ? 0 : 220);
    }

    if (ui.modal) {
      ui.modal.querySelectorAll('[data-ted-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && ui.modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }

    function applyCategory(followers) {
      var category = classify(config.categories || [], followers);
      if (!category) return;

      state.followers = Number(followers);
      state.categoryTitle = category.title;
      renderCategory(ui, category, state.followers, config);

      hide(ui.manual);
      hide(ui.progress);
      if (ui.checker) ui.checker.classList.add('is-complete');
      show(ui.result);
      show(ui.interest);

      if (ui.result) {
        ui.result.classList.remove('ted-ambassador__result--animate');
        void ui.result.offsetWidth;
        ui.result.classList.add('ted-ambassador__result--animate');
      }

      requestAnimationFrame(function () {
        smoothScrollTo(ui.result);
      });
    }

    if (ui.lookupForm) {
      ui.lookupForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        var username = normalizeUsername(ui.username && ui.username.value);
        if (!username) {
          if (ui.username) ui.username.focus();
          return;
        }

        state.instagram = username;
        if (ui.username) ui.username.value = '@' + username;

        hide(ui.manual);
        hide(ui.result);
        hide(ui.interest);
        if (ui.checker) ui.checker.classList.remove('is-complete');
        show(ui.progress);
        ui.progress.classList.add('is-active');
        if (ui.checkBtn) ui.checkBtn.disabled = true;

        var verified = null;
        var verifyPromise = tryVerifyFollowers(config.verifyEndpoint, username);
        await Promise.all([verifyPromise.then(function (n) {
          verified = n;
        }), wait(prefersReducedMotion() ? 200 : 1600)]);

        ui.progress.classList.remove('is-active');
        hide(ui.progress);
        if (ui.checkBtn) ui.checkBtn.disabled = false;

        if (verified != null) {
          if (ui.followers) ui.followers.value = String(verified);
          applyCategory(verified);
          return;
        }

        show(ui.manual);
        if (ui.followers) {
          ui.followers.value = '';
          ui.followers.focus();
        }
      });
    }

    if (ui.manualForm) {
      ui.manualForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var followers = ui.followers ? Number(ui.followers.value) : NaN;
        if (!isFinite(followers) || followers < 0) {
          if (ui.followers) ui.followers.focus();
          return;
        }
        applyCategory(followers);
      });
    }

    if (ui.interestSubmit) {
      ui.interestSubmit.addEventListener('click', function () {
        if (!state.instagram) {
          if (ui.username) ui.username.focus();
          return;
        }

        var handle = '@' + state.instagram;
        var templateVars = {
          instagram: handle,
          email: 'Contact via Instagram',
          followers: formatCount(state.followers != null ? state.followers : ''),
          category: state.categoryTitle || '',
        };
        var emailBody = buildEmailBody(config.emailTemplate, templateVars);
        var whatsappBody = buildEmailBody(
          config.whatsappTemplate || config.emailTemplate,
          templateVars
        );

        ui.interestSubmit.disabled = true;
        openModal();

        Promise.all([
          notifyInterestEmail(config, templateVars),
          notifyNtfy(config, emailBody || whatsappBody),
        ]).finally(function () {
          notifyWhatsApp(config, whatsappBody);
          setTimeout(function () {
            ui.interestSubmit.disabled = false;
          }, 2500);
        });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-ted-ambassador]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
